import { useCallback } from "react";
import { useAuth } from "@clerk/react";
import { toast } from "sonner";
import { api } from "../../lib/api";

export const useAdminApi = () => {
  const { getToken } = useAuth();
  return useCallback(async (method, url, data) => {
    const token = await getToken();
    try {
      const r = await api.request({ method, url, data, headers: { Authorization: `Bearer ${token}` } });
      return r.data;
    } catch (e) {
      const detail = e.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : Array.isArray(detail) ? "Vérifiez les champs du formulaire" : "Une erreur est survenue");
      throw e;
    }
  }, [getToken]);
};

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="mb-1.5 block text-sm font-semibold">{label}</span>
    {children}
  </label>
);
